import { apiClient } from './apiClient';

const base = '/api/agent/keys';

export const agentKeyService = {
  get: (options = {}) => {
    const { includeKey } = options;
    const queryParams = new URLSearchParams();
    if (includeKey) {
      queryParams.append('includeKey', 'true');
    }
    const queryString = queryParams.toString();
    const endpoint = queryString ? `${base}?${queryString}` : base;
    return apiClient.get(endpoint);
  },
  generate: () => apiClient.post(`${base}/generate`, {}),
  delete: () => apiClient.del(base),
};

export default agentKeyService;
